import React, { useState } from "react";
import AddComponentForm from "./AddComponentForm";
import InstallationInterventionList from "../../Installation/components/InstallationInterventionList";
import Modal from "../../../../common/components/elements/Modal";
import I18n from "i18n-js";
import InstallationComponentListEdit from "./InstallationComponentListEdit";
import { array, func, shape } from "prop-types";
import InstallationAnalysesList from "../../Installation/components/InstallationAnalysesList";

InstallationEditFormTablesSection.propTypes = {
  installation: shape(),
  state: shape(),
  dispatch: func,
  interventions: array,
  analyses: array,
};

export default function InstallationEditFormTablesSection({
  installation,
  state,
  dispatch,
  interventions,
  analyses,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Modal
        isOpen={isModalOpen}
        title={"Hello"}
        onClose={() => setIsModalOpen(false)}
      >
        <AddComponentForm
          nomenclaturesList={state.nomenclaturesList}
          dispatch={dispatch}
          close={() => setIsModalOpen(false)}
        />
      </Modal>
      <InstallationComponentListEdit
        components={[...state.addedComponents, ...state.components]}
        nomenclaturesList={state.nomenclaturesList ?? []}
        dispatch={dispatch}
        onAdd={() => setIsModalOpen(true)}
      />
      <div className="detail-header">
        <div>{I18n.t("pages.installations.view.interventions:header")}</div>
        <div className="detail-header-band"></div>
      </div>
      <InstallationInterventionList installation={installation} interventions={interventions} />
      <div className="detail-header">
        <div>{I18n.t("pages.installations.view.analyses:header")}</div>
        <div className="detail-header-band"></div>
      </div>
      <InstallationAnalysesList analyses={analyses} />
    </>
  );
}
